function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import tasks from '@/js/tasks';
import { envConfig } from '@/js/constants';
import { appApis, validateError, loginObj } from '@/services/base';

/**
 * queryService takes any argument.
 * @param  {Object}  data
 * { query: query in to filter in datacatalog format,
 *   pageSize: limit to consult query,
 *   email: user email
 * }
 * @return {Object}  records filtered by query
 */
appApis.queryService = function () {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  data.login = loginObj();
  data.email = data.email ? data.email.toLowerCase() : null;
  tasks.lockScreen.lock();
  return appApis.post('/queryService/', data).then(function (res) {
    tasks.lockScreen.unlock();
    return res.data;
  }).catch(function (err) {
    var message = '(queryService) List table tags';
    var response = validateError(err, message, function () {
      appApis.queryService(data);
    });
    return response;
  });
};

/**
 * listTagEntry takes any argument.
 * @param {Object} data
 * {
 *    relativeResourceName : relative resouse where table is
 *    pageSize: limit to query
 *    email: username email
 *    index_node: node where table is
 *    domain_table: domain where table is
 * }
 * @return {Object}  table's tags
 */
appApis.listTagEntry = function () {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  data.login = loginObj();
  data.email = data.email ? data.email.toLowerCase() : null;
  tasks.lockScreen.lock();
  return appApis.post('/listTagEntryRefact/', data).then(function (res) {
    tasks.lockScreen.unlock();
    return res.data;
  }).catch(function (err) {
    var message = '(listTagEntryRefact) Get Tags table detail';
    return validateError(err, message, function () {
      appApis.listTagEntry(data);
    });
  });
};

/**
 * updateTags takes any argument.
 * @param {Object} data
 * {
 *    tags: table's tags,
 *    tableReference: table reference (tableId, datasetId, projectId),
 *    relativeResourceName: relative resource where table is,
 *    index_node: node where table is,
 *    domain_table: domain where table is
 * }
 * @return {Object} process status
 */
appApis.updateTags = function () {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  data.login = loginObj();
  tasks.lockScreen.lock(true);
  return appApis.post('/updateTags/', data).then(function (response) {
    // await for GCP api update
    return new Promise(function (res) {
      setTimeout(function () {
        tasks.lockScreen.unlock();
        res(response.data);
      }, envConfig.timeWaitForApi);
    });
  }).catch(function (err) {
    console.error('Entramos a este error', err);
    var message = '(updateTags) updating tags table';
    return validateError(err, message, function () {
      appApis.updateTags(data);
    });
  });
};

/**
 *  takes any argument.
 * @param {Object} data
 * {
 *    operator: table's owner
 *    type_flow: type of process (ACCESS, METADATA)
 *    table_id: table name
 *    relativeResourceName: relative resource where table is
 *    commentary: commentary of the process
 *    fields: fields to save
 *    tableReference: table reference (tableId, datasetId, projectId)
 *    endDate: date limit of the requests
 *    applicant: username who is requesting
 *    extraParams: extra params such as links to cloud storage,
 *    index_node: node where table is
 *    domain_table: domain where table is
 * }
 * @return {Object} response of the status process
 */
appApis.initApprovalFlow = function (data) {
  data.login = loginObj();
  var applicant = data.applicant || window.userInfo.email;
  data.applicant = applicant.toLowerCase();
  tasks.lockScreen.lock(true);
  return appApis.post('/init_approval_flow/', data).then(function (res) {
    tasks.lockScreen.unlock();
    return res.data;
  }).catch(function (err) {
    var message = '(initApprovalFlow) setting aproval flow';
    return validateError(err, message, function () {
      appApis.initApprovalFlow(data);
    });
  });
};

/**
 * listPendingApproval takes any argument.
 * @param {String} typeFlow type of flow (ACCESS, METADATA)
 * @param {String} email username who was asked
 *
 * @return {Object} records in pending state to approve
 */
appApis.listPendingApproval = function (typeFlow) {
  var email = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var login = loginObj();
  email = email || window.userInfo.email;
  email = email.toLowerCase();
  var body = {
    email: email,
    typeFlow: typeFlow,
    login: login
  };
  tasks.lockScreen.lock();
  return appApis.post('/list_pending_approval/', body).then(function (res) {
    tasks.lockScreen.unlock();
    return res.data;
  }).catch(function (err) {
    var message = '(listPendingApproval) getting aproval flow list';
    return validateError(err, message, function () {
      appApis.listPendingApproval(typeFlow);
    });
  });
};

/**
 * changeMetadata takes any argument.
 * @param {Object} data
 * {
 *    tags: tags to change
 *    id_firestore: Firestore's document id
 *    response: request message
 *    index_node: node where table is
 *    domain_table domain where table is
 * }
 * @return {Object} State of the process
 */
appApis.changeMetadata = function () {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  data.login = loginObj();
  tasks.lockScreen.lock(true);
  return appApis.post('/changeMetadata/', data).then(function (res) {
    tasks.lockScreen.unlock();
    return res.data;
  }).catch(function (err) {
    var message = '(changeMetadata) setting metadata table';
    return validateError(err, message, function () {
      appApis.changeMetadata(data);
    });
  });
};

/**
 * listFlowsUser takes any argument.
 * @param {Object} data
 * {
 *    email: user email,
      init_date:  start date of the activity
      end_date: end date of the activity
      metadata,
      access_required: type of access requested
      access_response: response to requested access
 * }
 * @return {Object} records of the activity log
 */
appApis.listFlowsUser = function () {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  data.login = loginObj();
  var email = data.email ? data.email.toLowerCase() : null;
  data.email = email;
  tasks.lockScreen.lock();
  return appApis.post('/listFlowsUser/', data).then(function (res) {
    tasks.lockScreen.unlock();
    return res.data;
  }).catch(function (err) {
    var message = '(listFlowsUser) Getting user flows';
    return validateError(err, message, function () {
      appApis.listFlowsUser(data);
    });
  });
};

/**
 *  assignTemporaryOwner takes any argument.
 * @param {Object} data
 * {
 *    resourceName: relative resource where table is
 *    email: mail of the user to whom the table will be temporarily assigned
 *    endDate: end date of temporary assignment
 *    startDate: start date of temporary assignment
 *    tags: tags to save
 *    index_node: node where the table is
 *    domain_table: domain where the table is
 * }
 * @return {Object} State of the process
 */
appApis.assignTemporaryOwner = function () {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  data.login = loginObj();
  var email = data.email ? data.email.toLowerCase() : null;
  data.email = email;
  tasks.lockScreen.lock();
  return appApis.post('/createTempOwner/', data).then(function (res) {
    tasks.lockScreen.unlock();
    return res.data;
  }).catch(function (err) {
    var message = '(assignTemporaryOwner) setting temporal owner';
    return validateError(err, message, function () {
      appApis.assignTemporaryOwner(data);
    });
  });
};

/**
 * tempOwnerAllTablas takes any argument.
 * @param {Object} data
 * {
 *    email: mail of the user to whom the table will be temporarily assigned,
 *    endDate: end date of temporary assignment
 *    startDate: start date of temporary assignment
      operator: table owner,
      relativeResourceNames: relative resources from table for eternal assignment
 * }
 * @return {Object} State of the process
 */
appApis.tempOwnerAllTablas = function () {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  data.login = loginObj();
  var email = data.email ? data.email.toLowerCase() : null;
  data.email = email;
  return appApis.post('/tempOwnerAllTables/', data).then(function (res) {
    tasks.lockScreen.unlock();
    return res.data;
  }).catch(function (err) {
    var message = '(tempOwnerAllTablas) setting all to temporal owner';
    return validateError(err, message, function () {
      appApis.tempOwnerAllTablas(data);
    });
  });
};

/**
 * tableLinage takes any argument.
 * @param {Object} data
 * {
 *    tableId: table id
 *    tableDomain: table domain
 *    dateInit: start date of the table linage
 *    dateEnd: end date of the table linage
 *    namespace:  zone plus enviroment of the table
 *    email: user mail
 * }
 * @return {Object}
 */
appApis.tableLinage = function () {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  data.login = loginObj();
  var email = data.email ? data.email.toLowerCase() : null;
  data.email = email;
  return appApis.post('/tableLinage/', data).then(function (res) {
    tasks.lockScreen.unlock();
    return res.data;
  }).catch(function (err) {
    var message = '(tableLinage) getting object for lineage';
    return validateError(err, message, function () {
      appApis.tableLinage(data);
    });
  });
};

/**
 * uploadFile takes any argument.
 * @param {Object} data
 * {
 *    content: File content in base64
 *    filename: File name
 *    type: FILES|WORKBOOKS|DATASOURCES, DEFAULT: FILES
 *    domain_source: Domain source, NOTE: NO USER DOMAIN
 * }
 * @return {Object} Status of th process
 */
appApis.uploadFile = function (data) {
  var login = loginObj();
  var body = _objectSpread(_objectSpread({}, data), {}, {
    login: login
  });
  // return appApis.post('/upload_file/', body).then(res => {
  //   return res['data']
  // })
  tasks.lockScreen.lock();
  return appApis.post('/upload_file/', body).then(function (res) {
    tasks.lockScreen.unlock();
    return res.data;
  }).catch(function (err) {
    var message = '(uploadFile) Access Request';
    var response = validateError(err, message, function () {
      appApis.uploadFile(body);
    });
    return response;
  });
};

/**
 * deleteFile takes any argument.
 * @param {Object} data
 * {
 *    fileId: file name to delete
 * }
 * @return {Object} Status of th process
 */
appApis.deleteFile = function (data) {
  var login = loginObj();
  var body = _objectSpread(_objectSpread({}, data), {}, {
    login: login
  });
  return appApis.post('/delete_file/', body);
};

/**
 * @param  {String}  email     Email of user login
 * @param  {String}  domainQuery
 * @param  {String}  query     Format for Data Catalog
 * @param  {Int}     pageSize  Number objects to return
 * @param  {Boolean} searchWithTags
 * @param  {Boolean} allDomains
 * @param  {String}  pageToken Token for nextcall next or previous pagination items
 * @param  {Object}  conditions
 * @return {Object} with needle arraty tables list:
*                  {next_page_token, tables: [{relativeResourceName, id, schema:{fields:[]}, tableReference...},...]}
 */

appApis.queryServiceNew = function () {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // old Params: email, domainQuery, query, pageSize = 10, searchWithTags = false,
  // allDomains = false, approval_flow = false, pageToken = null, conditions = null, noProcessQuery = false

  var login = loginObj();
  data.email = data.email ? data.email.toLowerCase() : null;
  var body = _objectSpread({
    login: login
  }, data);
  tasks.lockScreen.lock();
  return appApis.post('/queryServiceRefact/', body).then(function (res) {
    tasks.lockScreen.unlock();
    return res.data;
  }).catch(function (err) {
    var message = '(queryServiceNew) List table tags';
    var response = validateError(err, message, function () {
      appApis.queryServiceNew(data);
    });
    // const response = validateError(err, message)
    return response;
  });
};
appApis.queryGetTable = function () {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // old Params: email, domainQuery, query, pageSize = 10, searchWithTags = false,
  // allDomains = false, approval_flow = false, pageToken = null, conditions = null, noProcessQuery = false

  var login = loginObj();
  data.email = data.email ? data.email.toLowerCase() : null;
  var body = _objectSpread({
    login: login
  }, data);
  tasks.lockScreen.lock();
  return appApis.post('/query_get_table', body).then(function (res) {
    tasks.lockScreen.unlock();
    return res.data;
  }).catch(function (err) {
    var message = '(queryServiceNew) List table tags';
    var response = validateError(err, message, function () {
      appApis.queryGetTable(data);
    });
    // const response = validateError(err, message)
    return response;
  });
};
appApis.queryServiceApproval = function () {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // old Params: email, domainQuery, query, pageSize = 10, searchWithTags = false,
  // allDomains = false, approval_flow = false, pageToken = null, conditions = null, noProcessQuery = false

  var login = loginObj();
  data.email = data.email ? data.email.toLowerCase() : null;
  var body = _objectSpread({
    login: login
  }, data);
  tasks.lockScreen.lock();
  return appApis.post('/queryServiceApprovalFlow/', body).then(function (res) {
    tasks.lockScreen.unlock();
    return res.data;
  }).catch(function (err) {
    var message = '(queryServiceNew) List table tags';
    var response = validateError(err, message, function () {
      appApis.queryServiceApproval(data);
    });
    // const response = validateError(err, message)
    return response;
  });
};

/**
 * @param  {String}  url Link file in bucket
 * @return {Object}
 */

appApis.readFile = function (url) {
  var login = loginObj();
  var params = {
    login: login,
    url: url
  };
  return appApis.post('/read_file/', params).then(function (res) {
    return res['data'];
  });
};

/**
 * @param  {String}  relativeResourceName
 * @param  {String}  domain_table
 * @return {Object}
 */

appApis.syncTableSchema = function () {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // old Params: email, domainQuery, query, pageSize = 10, searchWithTags = false,
  // allDomains = false, approval_flow = false, pageToken = null, conditions = null, noProcessQuery = false

  var login = loginObj();
  var body = _objectSpread({
    login: login
  }, data);
  tasks.lockScreen.lock();
  return appApis.post('/syncTableSchema/', body).then(function (res) {
    tasks.lockScreen.unlock();
    return res.data;
  }).catch(function (err) {
    var message = '(syncTableSchema) List table tags';
    var response = validateError(err, message);
    return response;
  });
};
appApis.syncTableauDatasource = function () {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var login = loginObj();
  var body = _objectSpread({
    login: login
  }, data);
  tasks.lockScreen.lock();
  return appApis.post('/extractTableauDatasource/', body).then(function (res) {
    tasks.lockScreen.unlock();
    return res.data;
  }).catch(function (err) {
    console.info(err);
  });
};
appApis.syncTableauWorkbook = function () {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var login = loginObj();
  var body = _objectSpread({
    login: login
  }, data);
  tasks.lockScreen.lock();
  return appApis.post('/extractTableauWorkbook/', body).then(function (res) {
    tasks.lockScreen.unlock();
    return res.data;
  }).catch(function (err) {
    console.info(err);
  });
};
appApis.tableauBulkDataSource = function () {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var login = loginObj();
  var body = _objectSpread({
    login: login
  }, data);
  tasks.lockScreen.lock();
  return appApis.post('/tableauBulkDataSource/', body).then(function (res) {
    tasks.lockScreen.unlock();
    return res.data;
  }).catch(function (err) {
    console.info(err);
  });
};
appApis.tableauBulkWorkbook = function () {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var login = loginObj();
  var body = _objectSpread({
    login: login
  }, data);
  tasks.lockScreen.lock();
  return appApis.post('/tableauBulkWorkbook/', body).then(function (res) {
    tasks.lockScreen.unlock();
    return res.data;
  }).catch(function (err) {
    console.info(err);
  });
};
appApis.getIsTableauActive = function () {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var login = loginObj();
  var body = _objectSpread({
    login: login
  }, data);
  if (!window.userInfo.email) {
    return new Promise(function (res) {});
  }
  tasks.lockScreen.lock();
  return appApis.post('/isTableauActive/', body).then(function (res) {
    tasks.lockScreen.unlock();
    return res.data;
  }).catch(function (err) {
    console.info(err);
  });
};
appApis.setDatasourcePermission = function () {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var login = loginObj();
  var body = _objectSpread({
    login: login
  }, data);
  tasks.lockScreen.lock();
  return appApis.post('/setDatasourcePermission/', body).then(function (res) {
    tasks.lockScreen.unlock();
    return res.data;
  }).catch(function (err) {
    console.info(err);
  });
};
appApis.getUserTableauByEmail = function () {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var login = loginObj();
  var body = _objectSpread({
    login: login
  }, data);
  tasks.lockScreen.lock();
  return appApis.post('/userTableauByEmail/', body).then(function (res) {
    tasks.lockScreen.unlock();
    return res.data;
  }).catch(function (err) {
    console.info(err);
  });
};
appApis.checkUserHasAccess = function () {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var login = loginObj();
  var domain = window.userInfo.domain;
  var body = _objectSpread({
    login: login,
    domain: domain
  }, data);
  tasks.lockScreen.lock();
  return appApis.post('/checkUserHasAccess/', body).then(function (res) {
    tasks.lockScreen.unlock();
    return res.data;
  }).catch(function (err) {
    console.info(err);
  });
};

/* appApis.getListProjects = (data = {}) => {
  const login = loginObj()
  const domain = window.userInfo.domain
  const params = { ...login, domain, ...data }

  tasks.lockScreen.lock()
  return appApis.get('/listProjects/', { params }).then(res => {
    tasks.lockScreen.unlock()
    return res.data
  }).catch(err => {
    console.info(err)
  })
} */

appApis.getCompanyCode = function () {
  var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
  var body = {
    login: login
  };
  tasks.lockScreen.lock();
  return appApis.post('/initial_setups/get_business_code', body, {
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(function (res) {
    tasks.lockScreen.unlock();
    return res.data;
  }).catch(function (err) {
    var message = '(getAreas) listar areas en user profile';
    // const response = validateError(err, message)
    //return validateError(err, message, () => { this.getSegmentos(data) })
  });
};
export { appApis as default, validateError };